/* eslint-disable react/jsx-key */
import Dashboard from 'components/Layout/Dashboard/Dashboard';
import { BoxWrapper } from 'components/Base';
import React, { useEffect, useState } from 'react';
import SearchGeneric from 'components/Fields/Search/SearchGeneric';
import api from 'api';
import Routes from 'consts/routes';
import { useHistory } from 'react-router-dom';
import LinkCard from 'components/Homepage/components/LinkCard';
import Grid from '@material-ui/core/Grid';
import { Chip, makeStyles } from '@material-ui/core';
import { greenText, linkColor, redBackground, redText } from 'utils/colors';
import NewProviderModal from './NewProviderModal';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';

const useStyles = makeStyles({
  link: {
    textDecoration: 'none',
    color: linkColor,
    fontWeight: 600,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
});

const MpsHubPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const [providers, setProviders] = useState([] as any[]);
  const [favouriteProviders, setFavouriteProviders] = useState([] as any);
  const [search, setSearch] = useState('');
  const [filteredFavouriteProviders, setFilteredFavouriteProviders] = useState(
    [] as any
  );
  const [filteredProviders, setFilteredProviders] = useState([] as any);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const filterItems = (items: any) => {
    return items.filter((item: any) =>
      item.name.toLowerCase().includes(search.toLowerCase())
    );
  };

  useEffect(() => {
    api.getMpsProviders().then(({ data }) => {
      setProviders(data.results);
    });
    api.getMpsProvidersFavourites().then(({ data }) => {
      setFavouriteProviders(
        data.results.map((provider: any) => provider.provider)
      );
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setFilteredProviders(filterItems(providers));
    setFilteredFavouriteProviders(filterItems(favouriteProviders));
    // eslint-disable-next-line
  }, [providers, favouriteProviders, search]);

  const ProviderList = ({ list }: any) => (
    <Grid style={{ padding: '1rem' }} container spacing={1}>
      {[...list]
        .sort((a, b) => {
          // First, prioritize claimed items
          if (a.claimed && !b.claimed) return -1;
          if (!a.claimed && b.claimed) return 1;

          // If both are claimed or unclaimed, sort by name
          return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
        })
        .map((item: any, i: number) => (
          <Grid item xs={6} md={4} lg={3}>
            <LinkCard
              onClick={() => {
                localStorage.setItem('providerName', item.name);
                history.push(
                  Routes.MPS_HUB.PROVIDER.replace(':provider', item.slug)
                );
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '1rem',
                  alignItems: 'center'
                }}
              >
                <img
                  key={i}
                  src={item.logo_url}
                  alt={item.name}
                  style={{
                    width: '100%',
                    maxWidth: '200px',
                    height: '150px',
                    objectFit: 'contain',
                    marginBottom: '0.5rem'
                  }}
                />
                <div
                  style={{
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '.5rem'
                  }}
                >
                  {item.name}
                  {item.claimed ? (
                    <VerifiedUserIcon style={{ fill: greenText }} />
                  ) : (
                    <Chip
                      style={{
                        backgroundColor: redBackground,
                        color: redText
                      }}
                      size="small"
                      label="Limited"
                    />
                  )}
                </div>
              </div>
            </LinkCard>
          </Grid>
        ))}
    </Grid>
  );

  return (
    <Dashboard>
      {providers.length > 0 && (
        <>
          <div
            style={{
              marginTop: '2rem',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '2rem'
            }}
          >
            <div style={{ width: '350px' }}>
              <SearchGeneric label="Search Provider" onSearch={setSearch} />
            </div>
          </div>
          {favouriteProviders.length > 0 &&
            filteredFavouriteProviders.length > 0 && (
              <BoxWrapper
                title="Favourite providers"
                style={{
                  margin: '2rem 0'
                }}
              >
                <ProviderList list={filteredFavouriteProviders} />
              </BoxWrapper>
            )}
          <BoxWrapper
            title="All providers"
            style={{
              margin: '2rem 0'
            }}
          >
            {filteredProviders.length > 0 ? (
              <ProviderList list={filteredProviders} />
            ) : (
              <div style={{ display: 'inline', padding: '1rem' }}>
                If you can't find your Portfolio Provider,{' '}
                <span
                  className={classes.link}
                  onClick={() => setIsModalOpen(true)}
                >
                  click here
                </span>{' '}
                to send us a request.
              </div>
            )}
          </BoxWrapper>
        </>
      )}
      <NewProviderModal
        isModalOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
      />
    </Dashboard>
  );
};

export default MpsHubPage;
